import type { FC } from 'react';

import classNames from 'classnames';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import FailureStatuses from './statuses/failure_statuses';
import InfoStatuses from './statuses/info_statuses';
import LiveStatus from './statuses/live_status';
import WarningStatuses from './statuses/warning_statuses';

import styles from './asset_status_icon_detailed.module.css';

type DetailedStatusIconProps = {
  object: SearchItemEntity;
  expendedPod?: boolean;
  className?: string;
};

const DetailedStatusIcon: FC<DetailedStatusIconProps> = (props) => {
  return (
    <div className={classNames(styles.status_container, props.className)}>
      <LiveStatus object={props.object} />
      <FailureStatuses object={props.object} />
      <WarningStatuses object={props.object} expandedPod={false} />
      <InfoStatuses object={props.object} />
    </div>
  );
};

export default DetailedStatusIcon;
